// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentTitle_root__h776J"};